export default "__VITE_ASSET__CXsNL0MT__"